import { forwardRef, useState } from 'react';
import cx from 'classnames';
import { ButtonVariant } from '../../Button';
import { BaseButton } from '../../Button/__internal__';
import { getToggleButtonDesignTokens } from '../ToggleButton';
import cn from './BaseToggleButton.css.json';
import './BaseToggleButton.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseToggleButton = /*#__PURE__*/forwardRef(function BaseToggleButton({
  className,
  pressed = false,
  noAriaPressed = false,
  ...props
}, ref) {
  const [isActive, setIsActive] = useState(false);
  // Unpressed ToggleButtons use the normal button styles. For pressed state we override Button's
  // tokens to use the correct pressed tokens.
  const classNames = [className, props.disabled && cn.disabled, pressed && cn.pressed, cn.toggle];

  // NOTE: aria-pressed is overridable, for a11y (check WAI ARIA 1.1 best practices)
  return /*#__PURE__*/_jsx(BaseButton, {
    ...props,
    "aria-pressed": noAriaPressed ? undefined : pressed,
    className: cx(classNames),
    ref: ref,
    theme: (dt, data) => {
      const toggleButtonData = {
        ...data,
        pressed,
        isActive
      };
      const tokens = getToggleButtonDesignTokens(dt, toggleButtonData);
      const themeOverride = props.theme?.(dt, toggleButtonData);
      return {
        ...tokens,
        ...themeOverride
      };
    },
    variant: props.text === undefined ? ButtonVariant.Icon : ButtonVariant.Light,
    onKeyDown: e => {
      if (!props.disabled && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        setIsActive(true);
      }
    },
    onKeyUp: e => {
      if (!props.disabled && (e.key === 'Enter' || e.key === ' ') && isActive) {
        e.preventDefault();
        setIsActive(false);
      }
    }
  });
});
//# sourceMappingURL=BaseToggleButton.js.map